import { colors } from 'theme/colors';
import fonts from 'theme/designRefreshFonts';
import { styles } from 'theme/designRefreshStyles';
import { media } from 'theme/media';
import { screenSizes as screens } from 'theme/screenSizes';
import svgs from 'theme/svgs';

export const theme = {
  fonts,
  svgs,
  media,
  screens,
  colors,
  styles,
};
